import * as React from 'react';
import Loader from '../../../Components/Loader';
import { Modal } from '../../../Components/Modal';
import { AdminIcon } from '../../../Icons/AdminIcon';
import '../AdminGroups.css'
interface DeleteGroupModalProps {
  groupName: string;
  isDeleting: boolean;
  onDelete: () => Promise<void>;
  onClose: () => void;
}

export const DeleteGroupConfirmationModal = ({
  groupName,
  isDeleting,
  onDelete,
  onClose
}: DeleteGroupModalProps) => {
  return (
    <Modal className="admin-group-modal-layout" onClose={onClose}>
      <div className="admin-group-modal-close">
        <button type="button" aria-label="Stäng" onClick={onClose}>
          <AdminIcon.CrossClose fill="hsl(var(--primary))" width={18} />
        </button>
      </div>

      <div className="sheet-header-container">
        <h2 className="sheet-header-text">Ta bort grupp</h2>
        <p className="sheet-header-paragraph">
          Är du säker på att du vill ta bort <strong>{groupName}</strong>?
        </p>
      </div>

      <div className="admin-group-modal-footer">
        <button
          type="submit"
          className="sheet-form-submit-button warning-button"
          onClick={onDelete}
        >
          {isDeleting ? (
            <>
              <Loader loaderSize="SMALL" bgColor="white" /> Tar bort...
            </>
          ) : (
            <>
              <AdminIcon.Trashcan width={16} height={16} fill="white" />
              Bekräfta borttagning
            </>
          )}
        </button>
      </div>
    </Modal>
  );
};
